"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _Placement = require("../utils/Placement");

var _Use = require("../utils/Use");

var _PlacementConstants = require("../PlacementConstants");

var _memoWithDisplayName = _interopRequireDefault(require("../../utils/memoWithDisplayName"));

var _Styles = require("../../utils/Styles");

var mediumArrowSize = 16;
var smallArrowSize = 12;

var isShepherdArrowWhite = function isShepherdArrowWhite(placement) {
  return (0, _Placement.getSide)(placement) !== 'bottom' && (0, _Placement.getEdge)(placement) !== 'bottom';
};

var getBackgroundColor = function getBackgroundColor(_ref) {
  var color = _ref.color,
      placement = _ref.placement,
      popoverUse = _ref.popoverUse;

  if (color) {
    return color;
  }

  if (popoverUse === 'shepherd') {
    return isShepherdArrowWhite(placement) ? _colors.OLAF : _colors.THUNDERDOME;
  }

  return 'inherit';
};

var getSideStyles = function getSideStyles(_ref2) {
  var placement = _ref2.placement,
      width = _ref2.width;

  switch ((0, _Placement.getSide)(placement)) {
    case 'top':
      // Arrow points down
      return (0, _styledComponents.css)(["transform:rotate(45deg);top:calc(100% - ", "px);"], width / 2);

    case 'right':
      // Arrow points left
      return (0, _styledComponents.css)(["transform:rotate(135deg);left:-", "px;"], width / 2);

    case 'bottom':
      // Arrow points up
      return (0, _styledComponents.css)(["transform:rotate(-135deg);top:-", "px;"], width / 2);

    case 'left':
      // Arrow points right
      return (0, _styledComponents.css)(["transform:rotate(-45deg);left:calc(100% - ", "px);"], width / 2);

    default:
      return '';
  }
};

var getEdgeStyles = function getEdgeStyles(_ref3) {
  var inset = _ref3.inset,
      placement = _ref3.placement,
      width = _ref3.width;
  // Magic calculation, haven't quite figured this out yet
  var adjustedInset = inset + 3;

  switch ((0, _Placement.getEdge)(placement)) {
    case 'top':
      // Arrow is near the bottom of the left or right side
      return (0, _styledComponents.css)(["bottom:", "px;"], adjustedInset);

    case 'middle':
      return (0, _styledComponents.css)(["top:calc(50% - ", "px);"], width / 2);

    case 'bottom':
      // Arrow is near the top of the left or right side
      return (0, _styledComponents.css)(["top:", "px;"], adjustedInset);

    case 'left':
      // Arrow is near the right of the top or bottom side
      return (0, _styledComponents.css)(["right:", "px;"], adjustedInset);

    case 'center':
      return (0, _styledComponents.css)(["left:calc(50% - ", "px);"], width / 2);

    case 'right':
      // Arrow is near the left of the top or bottom side
      return (0, _styledComponents.css)(["left:", "px;"], adjustedInset);

    default:
      return '';
  }
};

var getBorderUseStyles = function getBorderUseStyles(_ref4) {
  var placement = _ref4.placement,
      popoverUse = _ref4.popoverUse;

  if (popoverUse === 'default' || popoverUse === 'longform' || popoverUse === 'shepherd' && isShepherdArrowWhite(placement)) {
    return "1px solid " + _colors.BATTLESHIP;
  }

  return null;
};

var Arrow = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverArrow__Arrow",
  componentId: "la1n52-0"
})(["position:absolute;pointer-events:none;border:", ";clip-path:polygon(100% 100%,0 100%,100% 0);border-top-left-radius:100%;border-top-color:transparent !important;border-left-color:transparent !important;border-bottom-right-radius:", ";width:", ";height:", ";background-color:", ";", ";", ";.tether-pinned &{display:none;}"], getBorderUseStyles, function (_ref5) {
  var popoverUse = _ref5.popoverUse;
  return popoverUse.includes('tooltip') ? '3px' : null;
}, function (_ref6) {
  var width = _ref6.width;
  return (0, _Styles.toPx)(width);
}, function (_ref7) {
  var width = _ref7.width;
  return (0, _Styles.toPx)(width);
}, getBackgroundColor, getSideStyles, getEdgeStyles);

var UIPopoverArrow = (0, _memoWithDisplayName.default)('UIPopoverArrow', function (_ref8) {
  var className = _ref8.className,
      width = _ref8.width,
      rest = (0, _objectWithoutProperties2.default)(_ref8, ["className", "width"]);
  return width === 0 ? null : _react.default.createElement(Arrow, Object.assign({}, rest, {
    className: (0, _classnames.default)('uiPopoverArrow private-popover__arrow', className),
    width: width
  }));
});

if (process.env.NODE_ENV !== 'production') {
  UIPopoverArrow.propTypes = {
    color: _propTypes.default.string,
    inset: _propTypes.default.number.isRequired,
    placement: _propTypes.default.oneOf(_PlacementConstants.PLACEMENTS).isRequired,
    popoverUse: _propTypes.default.oneOf(Object.keys(_Use.USE_CLASSES)),
    width: _propTypes.default.number
  };
}

UIPopoverArrow.defaultProps = {
  inset: 0,
  placement: 'top',
  width: 20
};
UIPopoverArrow.ARROW_SIZES = {
  none: {
    distance: 4,
    inset: 0,
    width: 0
  },
  medium: {
    distance: mediumArrowSize,
    inset: mediumArrowSize - 2,
    width: 20
  },
  small: {
    distance: smallArrowSize,
    inset: smallArrowSize - 2,
    width: 16
  }
};
var _default = UIPopoverArrow;
exports.default = _default;
module.exports = exports.default;